import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import SecuritizePage from '@securitize/ui-components/SecuritizePage';
import { SmallCalculator } from '../../../../../components/Calculator';
import SignInvestmentModal from '../SignInvestmentModal';
import { getOpportunity, updateOpportunity } from '../OpportunitiesDetailsPage/actions';
import { getOpportunityWizard } from '../OpportunityWizard/actions';

const OpportunityCalculator = (props) => {
  const {
    opportunity, opportunityId, onOpportunityUpdate, updateOpportunity, opportunityLoading,
    opportunityError, xs, md, editDisabled, getOpportunityWizard, getOpportunity, signedAgreement,
  } = props;
  const [formikBag, setFormikBag] = useState({});
  const [isModalLoading, setModalLoading] = useState(false);
  const [isModalOpen, setModalOpen] = useState(false);
  const { currency, amount } = opportunity.investorInvestmentDetails || {};
  const [calcData, setCalcData] = useState({});

  useEffect(() => {
    if (!opportunityLoading && !Object.keys(opportunity).length) getOpportunity(opportunityId);
  }, []);

  return (
    <SecuritizePage isLoading={opportunityLoading} isError={opportunityError}>
      <SmallCalculator
        xs={xs}
        md={md}
        editDisabled={editDisabled}
        isTokenCalculatorVisible={opportunity.isTokenCalculatorVisible}
        initValue={amount}
        currencyList={opportunity.currencies || []}
        initialCurrency={currency}
        onSave={(values, formik) => {
          setCalcData(values, formik);
          setFormikBag(formik);
          if (values.investValue !== amount || values.name !== currency) {
            if (signedAgreement.agreement) {
              setModalOpen(true);
            } else {
              updateOpportunity(opportunityId, { amount: values.investValue, currency: values.name },
                {
                  onFinish: () => {
                    getOpportunityWizard(opportunityId);
                    onOpportunityUpdate();
                  },
                });
            }
          } else {
            formik.setSubmitting(false);
          }
        }}
        tokenDecimals={opportunity.tokenDecimals}
      />
      {
        !!Object.keys(calcData || {}).length
        && (
          <SignInvestmentModal
            isOpen={isModalOpen}
            onToggle={() => {
              setModalOpen(!isModalOpen);
              formikBag.setSubmitting(false);
            }}
            currency={calcData.name}
            isLoading={isModalLoading}
            onConfirm={() => {
              setModalLoading(true);
              updateOpportunity(opportunityId, { amount: calcData.investValue, currency: calcData.name },
                {
                  onFinish: () => {
                    formikBag.setSubmitting(false);
                    setModalLoading(false);
                    setModalOpen(false);
                    getOpportunityWizard(opportunityId);
                    onOpportunityUpdate();
                  },
                });
            }}
            investValue={calcData.investValue}
          />
        )
      }
    </SecuritizePage>
  );
};

OpportunityCalculator.defaultProps = {
  opportunity: {},
  opportunityLoading: false,
  opportunityError: false,
  getOpportunity: () => undefined,
  updateOpportunity: () => undefined,
  onOpportunityUpdate: () => undefined,
  getOpportunityWizard: () => undefined,
  xs: 12,
  md: 4,
  editDisabled: false,
  signedAgreement: {},
};

OpportunityCalculator.propTypes = {
  opportunity: PropTypes.objectOf(PropTypes.any),
  opportunityId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  opportunityError: PropTypes.bool,
  opportunityLoading: PropTypes.bool,
  updateOpportunity: PropTypes.func,
  onOpportunityUpdate: PropTypes.func,
  getOpportunityWizard: PropTypes.func,
  getOpportunity: PropTypes.func,
  xs: PropTypes.number,
  md: PropTypes.number,
  editDisabled: PropTypes.bool,
  signedAgreement: PropTypes.objectOf(PropTypes.any),
};

const mapStateToProps = (state) => {
  const { investment: { opportunity, agreement } } = state;
  return {
    opportunityError: opportunity.isError,
    opportunityLoading: opportunity.isLoading,
    opportunity: opportunity.data,
    signedAgreement: agreement.data,
  };
};

export default connect(
  mapStateToProps,
  { getOpportunity, updateOpportunity, getOpportunityWizard },
)(OpportunityCalculator);
